// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1UpYh","title":"AfterFrontImage_title__DcDHU"};